'use client';

import { useCustomerRatingsHistogramMessages } from '../useCustomerRatingsHistogramMessages/useCustomerRatingsHistogramMessages';

export type CustomerRatingMeterLabelProps = {
  rating: number;
};

/**
 * The CustomerRatingMeterLabel component displays a label for the customer rating meter
 */

export const CustomerRatingMeterLabel = ({ rating }: CustomerRatingMeterLabelProps) => {
  const { getLabel } = useCustomerRatingsHistogramMessages();

  return <div className="text-size-body-sm">{getLabel(rating)}</div>;
};
